<template>
    <div>
        <header
            class="login-header app-container flex flex-align-center flex-justify-sb"
        >
            <a href="#" class="header-back" @click.prevent="$router.go(-1)"></a>
            <router-link to="/" class="header__logo">
                <img src="img/logo.svg" />
            </router-link>
            <div class="login-header__dummy"></div>
        </header>

        <div class="app-content">
            <div class="app-container">
                <slot></slot>
            </div>
        </div>
        <div class="copyright">
            <div class="app-container">
                <div class="flex">
                    <div class="copyright__text">(c) 2019 Goldnet</div>
                    <a href="mailto:info@goldnet.market" class="copyright__link"
                        >Связаться с нами</a
                    >
                </div>
            </div>
        </div>

        <link
            rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            integrity="sha384-+d0P83n9kaQMCwj8F4RJB66tzIwOKmrdb46+porD/OvrJ+37WqIM7UoBtwHO6Nlg"
            crossorigin="anonymous"
        />
    </div>
</template>

<script>
export default {
    name: 'BlankLayout',
    mounted() {
        window.$('.filter').removeClass('show')
        window.$('.header__menu').attr('data-open', 'close')
        window.$('body').removeClass('noscroll')
    }
}
</script>
